/*
 * Jira Ticket:
 * Created Date: Wed, 13th May 2020, 12:34:59 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';
import moment from 'moment';

export const exportTowerInspectionCSVMutation = gql`
  mutation ExportTowerInspectionCSV($input: ExportTowerInspectionCSVInput!) {
    data: exportTowerInspectionCSV(input: $input) {
      downloadUrl
    }
  }
`;

export default async ({ client, params }) => {
  if (params.input.from) {
    params.input.from = moment(params.input.from).startOf('day');
  }
  if (params.input.to) {
    params.input.to = moment(params.input.to).endOf('day');
  }
  try {
    return client.mutate({
      mutation: exportTowerInspectionCSVMutation,
      variables: {
        ...params,
      },
    });
  } catch (e) {
    if (e.graphQLErrors && e.graphQLErrors.length) {
      const [error] = e.graphQLErrors;
      const message = error.message;
      throw new Error(message);
    }
    throw e;
  }
};
